"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lib = require("../lib");

var _common = require("../common");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Filter =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Filter, _PureComponent);

  function Filter(_props) {
    var _this;

    _classCallCheck(this, Filter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Filter).call(this, _props));

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (e, props) {
      if ((0, _lib.objHasOwnProperty)(props, 'value')) {
        var value = props.value;

        _this.setState({
          match: value
        }, function () {
          return _this.filter(e);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getFilterResult", function (options, match) {
      var filter = _this.props.filter;
      return options.filter(function (item, index, arr) {
        return filter(match, item, index, arr);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "filter", function (e) {
      var match = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.match;
      var filter = _this.props.filter;

      if (filter) {
        var options = _this.state.options;

        var result = _this.getFilterResult(options, match);

        _this.setState({
          result: result
        }, function () {
          var _this$props = _this.props,
              onChange = _this$props.onChange,
              name = _this$props.name;

          if (onChange) {
            onChange(e, {
              name: name,
              value: result
            });
          }
        });
      }
    });

    var _options = _props.options,
        _match = _props.match;
    _this.state = {
      prevProps: {
        options: _options,
        match: _match
      },
      match: _match,
      options: _options,
      result: _match ? _this.getFilterResult(_options, _match) : _options
    };
    return _this;
  }

  _createClass(Filter, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
          match = _this$state.match,
          options = _this$state.options,
          result = _this$state.result;
      return (0, _lib.getRenderProps)(children, {
        onChange: this.handleOnChange,
        getFilterResult: this.getFilterResult,
        filter: this.filter,
        match: match,
        options: options,
        result: result
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var options = props.options,
          match = props.match;
      return {
        // Store the previous props in state
        prevProps: {
          options: options,
          match: match
        },
        match: prevProps.match !== match ? match : state.match,
        options: prevProps.options !== options ? options : state.options
      };
    }
  }]);

  return Filter;
}(_react.PureComponent);

exports.default = Filter;

_defineProperty(Filter, "propTypes", {
  children: _common.customPropTypes.render.isRequired,
  options: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object])),
  match: _propTypes.default.string,
  name: _propTypes.default.string,
  onChange: _propTypes.default.func,
  filter: _propTypes.default.func
});

_defineProperty(Filter, "defaultProps", {
  options: [],
  match: '',
  name: null,
  onChange: null,
  filter: function filter(match, string) {
    return string.substring(0, match.length).toLowerCase().includes(match.toLowerCase());
  }
});